'use client'

import React from 'react'
import { ChevronDown } from 'lucide-react'

interface Props {
    targetId?: string
    text?: string
    className?: string
}

const ShowDetailsBtn = ({ targetId = 'full-description-section', text = 'Read Full Description', className = '' }: Props) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault()
        const el = document.getElementById(targetId)
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    return (
        <button
            type="button"
            onClick={handleClick}
            aria-label="Show full details"
            className={`inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-xl border border-[#f0ede8] bg-[#fffaf5] text-[#8C5826] hover:bg-[#F8F246]/30 transition-all duration-200 cursor-pointer group shadow-2xs ${className}`}
        >
            <span>{text}</span>
            <ChevronDown size={13} className="text-[#8C5826] transition-transform duration-200 group-hover:translate-y-0.5" />
        </button>
    )
}

export default ShowDetailsBtn
